import AppContext from "PFApp/app_context";
import Radios from "PFComponents/radios/radios";
import EchartsWrapper from "PFCore/helpers/echarts_wrapper";
import useInsightsApi from "PFCore/helpers/use_insights_api";
import React, { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import PiePreview from "../../previews/pie_preview";
import { pieChartConfig } from "./configs/pie_chart_config";
import css from "./roles_pie_chart.module.scss";

const RolesPieReasonChart = () => {
  const {
    store: {
      pages: {
        insights: { selectedFilters, setModalData }
      }
    }
  } = useContext(AppContext);

  const [graphData, setGraphData] = useState(null);
  const [selected, setSelected] = useState("accepted");
  const { insightsApi, insightsApiError } = useInsightsApi();
  const { t } = useTranslation("insights");

  useEffect(() => {
    insightsApi("/roles_pie_reasons", {
      ...selectedFilters
    }).then((res) => {
      setGraphData(res.reasons);
    });
  }, [selectedFilters]);

  if (insightsApiError) {
    return <PiePreview content={t("noData")} />;
  }

  const displayContent = Boolean(graphData);

  if (insightsApiError || graphData?.length === 0) {
    return <PiePreview animated content={t("noData")} />;
  }

  if (!displayContent) {
    return <PiePreview animated content={t("loading")} />;
  }

  return (
    <>
      <div className={css.rolesPieSection}>
        <h3>{t("shortlistReasons")}</h3>
        <div className={css.rolesPieSectionFilters}>
          <Radios
            items={[
              { id: "accepted", text: t("filters.accepted"), style: { marginRight: 20 } },
              { id: "declined", text: t("filters.declined") }
            ]}
            value={selected}
            handleChange={(item) => setSelected(item.id)}
          />
        </div>
        {graphData[selected] && graphData[selected]?.length > 0 ? (
          <EchartsWrapper
            onClick={(event) => {
              setModalData({
                shortlist_state: selected,
                shortlist_reason: event.name,
                title: t("shortlistReasonsModal", { status: selected, reason: event.name }),
                parent: "reasons",
                chartType: "roles_pie_reasons"
              });
            }}
            options={pieChartConfig(t("saveImage"), t("accessFrom"), graphData[selected])}
            height={600}
          />
        ) : (
          <PiePreview content={t("noData")} />
        )}
      </div>
    </>
  );
};

export default RolesPieReasonChart;
